import { Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);
export default SentryRoutes;
